
/**
 * Render posters under "Bonus Movies Included in Offer"
 * @param {Array} posters array of url and name
 */
export const renderIncludedMoviePosters = posters => {
    // Container DOM
    const parentContainer = document.querySelector('.poster-list');
    // Indiviual Poster wrapper
    let li;
    // Poster Image
    let img;

    // Loop through 
    posters.forEach(poster => {
        li = document.createElement('li');
        li.classList.add('poster');

        img = document.createElement('img');
        img.src = poster.url;
        img.alt = poster.name;

        li.appendChild(img);
        parentContainer.appendChild(li);
    })
}

